// Chat Component - Main export file

// Core architecture exports
export { ChatInstance } from './architecture/ChatInstance';
export { ChatInstanceManagerProvider } from './architecture/ChatInstanceManager';
export * from './architecture/types';

// Keep UI atoms if still referenced
export { ChatComposer } from './components/ChatComposer';
export { ChatMessageList } from './components/ChatMessageList';
export { LoadingIndicator } from './components/LoadingIndicator';
export { MessageBubble } from './components/MessageBubble';
export { MessageInput } from './components/MessageInput';

// Aliases for clearer naming
export { ChatInstanceManagerProvider as ChatInstancesProvider } from './architecture/ChatInstanceManager';
export { ChatView } from './architecture/ChatView';
